import React, {Component} from 'react'
import {Input} from "reactstrap"
import PropTypes from "prop-types"

class TableColumn extends Component {
    render() {
        const {onChangeInput, name, value, onPasteInput} = this.props

        return <td>
            <Input type='number' name={name} value={value} onChange={onChangeInput} onPaste={onPasteInput}
                          style={{"width": "100%"}}/></td>
    }
}

TableColumn.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.number,
    onChangeInput: PropTypes.func.isRequired,
}

export default TableColumn